import React from 'react';

interface Document {
  content: string;
}

const LegalContainer: React.FC<Document> = ({ content }) => (
  <React.Fragment>
    <div className="content" dangerouslySetInnerHTML={{ __html: content }} />
    {/* language=CSS */}
    <style jsx>{`
      .title,
      .date,
      .content {
        font-family: 'Volvo Novum', sans-serif;
        font-weight: 400;
      }

      .date,
      .content {
        width: 100%;
        display: block;
      }

      .title {
        font-weight: 600;
        font-size: 28px;
      }

      .date {
        margin-bottom: 1rem;
        font-size: 16px;
      }

      .content {
        font-size: 16px;
      }

      .content :global(a) {
        color: #000;
      }

      .content :global(h2),
      .content :global(h3) {
        font-weight: 500;
      }
    `}</style>
  </React.Fragment>
);

export default LegalContainer;
